export const el = {
  "language.label": "Γλώσσα",
  "language.el": "Ελληνικά",
  "language.en": "English",
  "language.fr": "Français",

  "common.loading": "Φόρτωση...",
  "common.error": "Σφάλμα",
  "common.empty": "Κενό",
  "common.save": "Αποθήκευση",
  "common.cancel": "Άκυρο",
  "common.edit": "Επεξεργασία",
  "common.delete": "Διαγραφή",
  "common.back": "Πίσω",
  "common.open": "Άνοιγμα",
  "common.search": "Αναζήτηση",
  "common.signIn": "Σύνδεση",
  "common.signOut": "Αποσύνδεση",
  "common.signInGoogle": "Σύνδεση με Google",
  "common.downloadPuls": "Κατέβασε το PULS",
  "common.downloadPulsBody": "Συνέχισε στο web viewer ή κατέβασε την εφαρμογή για πλήρη καταγραφή, ειδοποιήσεις και συμμετοχή.",
  "common.permissionDenied": "Δεν επιτρέπεται η πρόσβαση",
  "common.notFound": "Δεν βρέθηκε",
  "common.noDataYet": "Δεν υπάρχουν δεδομένα ακόμη",
  "common.viewActions": "Προβολή Δράσεων",
  "common.viewLocation": "Τοποθεσία",
  "common.refreshLater": "Δοκίμασε ξανά σε λίγο.",
  "common.noDate": "Χωρίς ημερομηνία",
  "common.status": "Κατάσταση",
  "common.confirm": "Επιβεβαίωση",

  "app.subtitle": "PULS V2 web portal",
  "app.routeLoadingTitle": "Φόρτωση PULS...",
  "app.routeLoadingBody": "Η ενότητα ανοίγει τώρα.",

  "auth.title": "Σύνδεση στο PULS",
  "auth.body": "Συνδέσου με Google για να ανοίξει το web portal. Δεν υπάρχει λειτουργία επισκέπτη.",
  "auth.loading": "Έλεγχος σύνδεσης...",
  "auth.signingIn": "Σύνδεση...",
  "auth.error": "Δεν ήταν δυνατή η σύνδεση. Έλεγξε ότι το popup δεν μπλοκαρίστηκε και δοκίμασε ξανά.",
  "auth.privacy": "Πολιτική απορρήτου",
  "auth.deleteAccount": "Διαγραφή λογαριασμού",
  "auth.guest": "Επισκέπτης",
  "auth.fullAccess": "Σύνδεση για πλήρη πρόσβαση",

  "nav.home": "Αρχική",
  "nav.dashboard": "Dashboard",
  "nav.brevetActions": "Brevet / Δράσεις",
  "nav.actions": "Δράσεις",
  "nav.myActions": "Οι δράσεις μου",
  "nav.routes": "Διαδρομές",
  "nav.myRoutes": "Οι διαδρομές μου",
  "nav.routeEditor": "Επεξεργασία / Δημιουργία",
  "nav.community": "Κοινότητα",
  "nav.communityRoutes": "Διαδρομές κοινότητας",
  "nav.segments": "Τμήματα",
  "nav.segmentRankings": "Βαθμολογία τμημάτων",
  "nav.tasks": "Ενέργειες",
  "nav.invitations": "Προσκλήσεις",
  "nav.sosHelp": "SOS / Βοήθεια",
  "nav.supportControl": "Υποστήριξη / Control",
  "nav.settings": "Ρυθμίσεις",
  "nav.profile": "Προφίλ",
  "nav.segmentDetail": "Λεπτομέρειες τμήματος",
  "nav.results": "Αποτελέσματα",
  "nav.liveBrevet": "Live Brevet",
  "nav.publicTracking": "Δημόσια παρακολούθηση",
  "nav.actionDetails": "Λεπτομέρειες δράσης",
  "nav.routeEditorFull": "Επεξεργασία / Δημιουργία διαδρομής",
  "nav.adminSection": "Διαχείριση",
  "nav.admin": "Admin panel",

  "dashboard.loadingTitle": "Φόρτωση PULS",
  "dashboard.loadingBody": "Γίνεται έλεγχος σύνδεσης.",
  "dashboard.publicTitle": "PULS Control Center",
  "dashboard.publicBody": "Δημόσια προβολή δράσεων και share links, με προσωπικό dashboard μετά τη σύνδεση.",
  "dashboard.welcomeTitle": "Καλώς ήρθες στο PULS",
  "dashboard.welcomeBody":
    "Μπορείς να βλέπεις δημόσιες δράσεις και live links. Για προσωπικές εκκρεμότητες, διαδρομές, διοργάνωση και προφίλ χρειάζεται σύνδεση με Google.",
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Σύνοψη για εκκρεμότητες, δικές σου δράσεις, διαδρομές και live ροές.",
  "dashboard.newAction": "Νέα Δράση",
  "dashboard.newRoute": "Νέα Διαδρομή",
  "dashboard.openTasks": "Άνοιγμα Ενεργειών",
  "dashboard.pendingTitle": "Εκκρεμότητες / Ενέργειες",
  "dashboard.pendingDescription": "Προσκλήσεις, support/control και SOS που χρειάζονται προσοχή.",
  "dashboard.total": "Σύνολο",
  "dashboard.myActionsTitle": "Οι δράσεις μου",
  "dashboard.myActionsDescription": "Προσεχείς ή ενεργές δράσεις όπου είσαι διοργανωτής.",
  "dashboard.myActionsEmpty": "Δεν υπάρχουν προσεχείς ή ενεργές δικές σου δράσεις.",
  "dashboard.myRoutesTitle": "Διαδρομές μου",
  "dashboard.myRoutesDescription": "Πρόσφατες αποθηκευμένες ή εισηγμένες διαδρομές από τον λογαριασμό σου.",
  "dashboard.synced": "συγχρονισμένες",
  "dashboard.recent": "Πρόσφατη",
  "dashboard.noRoutes": "Δεν υπάρχουν συγχρονισμένες διαδρομές ακόμη.",
  "dashboard.liveNowTitle": "Live τώρα",
  "dashboard.liveNowDescription": "Ενεργές δράσεις με γρήγορη πρόσβαση στο live race view.",
  "dashboard.liveNowEmpty": "Δεν υπάρχει ενεργή δική σου δράση αυτή τη στιγμή.",
  "dashboard.liveAccessEmpty": "Δεν υπάρχουν ενεργές δράσεις με πρόσβαση live αυτή τη στιγμή.",
  "dashboard.openLive": "Άνοιγμα Live",
  "dashboard.shortcutsTitle": "Γρήγορες ενέργειες",
  "dashboard.shortcutsDescription": "Οι συχνότερες κινήσεις για διοργάνωση, διαδρομές και λογαριασμό.",
  "dashboard.importRoute": "Εισαγωγή GPX/TCX/KML",
  "dashboard.sectionLoadError": "Δεν ήταν δυνατή η φόρτωση αυτής της ενότητας.",

  "admin.title": "Admin panel",
  "admin.subtitle": "Επαγγελματική σύνοψη για δράσεις, live λειτουργίες, εκκρεμότητες και βασική κατάσταση συστήματος.",
  "admin.loadingTitle": "Έλεγχος πρόσβασης",
  "admin.loadingBody": "Γίνεται έλεγχος admin δικαιωμάτων.",
  "admin.loadingDataTitle": "Φόρτωση admin στοιχείων",
  "admin.loadingDataBody": "Γίνεται ανάγνωση ασφαλών summaries.",
  "admin.loadErrorTitle": "Δεν ήταν δυνατή η φόρτωση",
  "admin.loadErrorBody": "Δοκίμασε ξανά σε λίγο.",
  "admin.partialError": "Δεν φορτώθηκαν κάποιες ενότητες διαχείρισης.",
  "admin.availabilityTitle": "Διαθεσιμότητα admin δεδομένων",
  "admin.availabilityAllowed": "Επιτρέπεται",
  "admin.availabilityPartial": "Μερική διαθεσιμότητα",
  "admin.availabilityBlocked": "Δεν επιτρέπεται",
  "admin.availabilitySection": "Ενότητα",
  "admin.availabilityReason": "Λόγος",
  "admin.availabilityDetails": "Λεπτομέρειες",
  "admin.availabilityErrors": "Σφάλματα",
  "admin.availabilityReasonOk": "Η ενότητα φορτώθηκε με τα τρέχοντα δικαιώματα.",
  "admin.availabilityPartialReason": "Φορτώθηκε μέρος των διαθέσιμων δεδομένων.",
  "admin.availabilityBlockedReason": "Δεν επιτρέπεται από τους τρέχοντες κανόνες.",
  "admin.availabilityRulesChangeRequired": "Απαιτείται αλλαγή κανόνων",
  "admin.availabilityLiveMirrors": "Live mirrors",
  "admin.availabilityLiveMirrorsLoaded": "Φορτώθηκαν {loaded}/{total} live αντίγραφα δράσεων.",
  "admin.availabilityActions": "Δράσεις",
  "admin.availabilityUsers": "Χρήστες",
  "admin.availabilityPending": "Εκκρεμότητες",
  "admin.availabilitySos": "SOS / Βοήθεια",
  "admin.availabilityCommunity": "Community",
  "admin.availabilityLive": "Live προβλήματα",
  "admin.accessDeniedTitle": "Δεν έχεις πρόσβαση σε αυτή τη σελίδα.",
  "admin.accessDeniedBody": "Η ενότητα είναι διαθέσιμη μόνο σε admin λογαριασμούς.",
  "admin.totalActions": "Σύνολο δράσεων",
  "admin.activeActions": "Live τώρα",
  "admin.upcomingActions": "Προσεχείς",
  "admin.openHelp": "Ανοιχτά SOS",
  "admin.communityRoutes": "Κοιν. διαδρομές",
  "admin.communitySegments": "Κοιν. τμήματα",
  "admin.users": "Χρήστες",
  "admin.liveNow": "Live τώρα",
  "admin.liveNowDescription": "Ενεργές δράσεις με γρήγορη πρόσβαση στο live race view.",
  "admin.noLiveNow": "Δεν υπάρχει ενεργή δράση αυτή τη στιγμή.",
  "admin.pendingTitle": "Εκκρεμότητες συστήματος",
  "admin.pendingDescription": "Προσκλήσεις, support/control και SOS που χρειάζονται προσοχή.",
  "admin.pendingInvitations": "Προσκλήσεις",
  "admin.pendingSupportControl": "Support/Control",
  "admin.openSos": "SOS",
  "admin.openTasks": "Σύνολο",
  "admin.recentActions": "Πρόσφατες δράσεις",
  "admin.recentActionsDescription": "Τελευταίες ενημερωμένες δράσεις με γρήγορο άνοιγμα ή επεξεργασία.",
  "admin.noActions": "Δεν υπάρχουν δράσεις.",
  "admin.noSearchResults": "Δεν βρέθηκαν αποτελέσματα.",
  "admin.quickActions": "Γρήγορες ενέργειες",
  "admin.quickActionsDescription": "Συντομεύσεις για τα βασικά admin workflows.",
  "admin.usersTitle": "Χρήστες / Ποδηλάτες",
  "admin.usersDescription": "Ασφαλής προβολή ονόματος, ρόλου και κατάστασης χωρίς ιδιωτικά στοιχεία.",
  "admin.userCard": "Καρτέλα",
  "admin.cyclistCardTitle": "Καρτέλα ποδηλάτη",
  "admin.basicInfo": "Βασικά στοιχεία",
  "admin.basicInfoBody": "Στοιχεία λογαριασμού που επιτρέπεται να δει ο admin.",
  "admin.technicalInfo": "Τεχνικά στοιχεία admin",
  "admin.technicalInfoBody": "Χρήσιμο για έλεγχο live συμμετοχής και υποστήριξη.",
  "admin.databaseId": "Database ID",
  "admin.authUid": "Auth UID",
  "admin.copyId": "Αντιγραφή ID",
  "admin.idCopied": "Το ID αντιγράφηκε.",
  "admin.displayName": "Όνομα",
  "admin.email": "Email",
  "admin.createdAt": "Δημιουργήθηκε",
  "admin.action": "Δράση",
  "admin.role": "Ρόλος",
  "admin.status": "Status",
  "admin.date": "Ημερομηνία",
  "admin.athleteNumber": "Αριθμός αθλητή",
  "admin.memberships": "Συμμετοχές / Δράσεις",
  "admin.membershipsBody": "Δράσεις όπου ο χρήστης εμφανίζεται ως αθλητής, διοργανωτής, support ή control.",
  "admin.liveNowUserBody": "Live εγγραφές όπου ο χρήστης εμφανίζεται στο public live mirror.",
  "admin.liveIssueTitle": "Live έλεγχος",
  "admin.liveIssueBody": "Γρήγορος έλεγχος live παρουσίας και δεδομένων για υποστήριξη.",
  "admin.liveEntriesCount": "Live εγγραφές",
  "admin.liveDelayedCount": "Καθυστέρηση / offline",
  "admin.lastUpdate": "Τελευταία ενημέρωση",
  "admin.lastKnownEvent": "Τελευταία δράση",
  "admin.liveStatusLive": "Live τώρα",
  "admin.liveStatusStale": "Καθυστέρηση",
  "admin.liveStatusOffline": "Εκτός σύνδεσης",
  "admin.liveStatusUnknown": "Άγνωστο",
  "admin.noRecentLiveUpdate": "Δεν υπάρχει πρόσφατη ενημέρωση",
  "admin.secondsAgo": "πριν {count} δευτ.",
  "admin.minutesAgo": "πριν {count} λεπτά",
  "admin.hoursAgo": "πριν {count} ώρες",
  "admin.liveHintLive": "Ο χρήστης ενημερώνεται κανονικά.",
  "admin.liveHintStale": "Δεν υπάρχει πρόσφατη ενημέρωση. Πιθανό θέμα σήματος, μπαταρίας ή background λειτουργίας.",
  "admin.liveHintOffline": "Δεν βρέθηκε ενεργό live σήμα για τον χρήστη.",
  "admin.copyDebugInfo": "Αντιγραφή debug info",
  "admin.copyLocation": "Αντιγραφή τοποθεσίας",
  "admin.openGoogleMaps": "Άνοιγμα σε Google Maps",
  "admin.debugCopied": "Το debug info αντιγράφηκε.",
  "admin.locationCopied": "Η τοποθεσία αντιγράφηκε.",
  "admin.noLiveSignal": "Δεν βρέθηκε ενεργό live σήμα.",
  "admin.updateAge": "Ηλικία ενημέρωσης",
  "admin.battery": "Μπαταρία",
  "admin.dataSource": "Πηγή δεδομένων",
  "admin.lastKnownLocation": "Τελευταία γνωστή τοποθεσία",
  "admin.noLocationAvailable": "Δεν υπάρχει διαθέσιμο στίγμα.",
  "admin.livePermissionFallback": "Δεν επιτρέπεται η ανάγνωση operational live δεδομένων. Προβάλλονται μόνο διαθέσιμα public δεδομένα.",
  "admin.openLiveFocus": "Άνοιγμα Live με focus",
  "admin.liveProblemsTitle": "Live προβλήματα",
  "admin.liveProblemsBody": "Συγκεντρωτικός έλεγχος αθλητών με καθυστέρηση, χωρίς σήμα ή SOS/Βοήθεια.",
  "admin.searchTitle": "Admin αναζήτηση",
  "admin.searchBody": "Αναζήτηση χρήστη, ποδηλάτη, δράσης, live προβλήματος ή ID.",
  "admin.searchPlaceholder": "Όνομα, email, αριθμός αθλητή, UID, δράση, eventId...",
  "admin.searchClear": "Καθαρισμός αναζήτησης",
  "admin.searchUsers": "Χρήστες / Ποδηλάτες",
  "admin.searchActions": "Δράσεις",
  "admin.searchLiveProblems": "Live προβλήματα",
  "admin.searchQuickIds": "Γρήγορα ID matches",
  "admin.searchNoResults": "Δεν βρέθηκαν αποτελέσματα.",
  "admin.openCard": "Άνοιγμα καρτέλας",
  "admin.openAction": "Άνοιγμα δράσης",
  "admin.editAction": "Επεξεργασία δράσης",
  "admin.liveOk": "Live OK",
  "admin.liveProblemAll": "Όλα",
  "admin.liveProblemHelp": "SOS / Βοήθεια",
  "admin.liveProblemStale": "Καθυστέρηση",
  "admin.liveProblemOffline": "Χωρίς σήμα",
  "admin.liveProblemGrouped": "Ανά δράση",
  "admin.issueTypeSOS": "SOS",
  "admin.issueTypeHELP": "Βοήθεια",
  "admin.issueTypeUnknown": "Άγνωστο",
  "admin.openLive": "Άνοιγμα Live",
  "admin.openUserCard": "Καρτέλα ποδηλάτη",
  "admin.noLiveProblems": "Δεν υπάρχουν live προβλήματα.",
  "admin.offlineDetectionPartial": "Δεν υπάρχουν αρκετά δεδομένα για offline detection.",
  "admin.userCardUnavailable": "Δεν υπάρχει ασφαλές user id για άνοιγμα καρτέλας.",
  "admin.unknownAthlete": "Συμμετέχων",
  "admin.liveGroupCounts": "Live {live} · Καθυστέρηση {stale} · Χωρίς σήμα {offline} · SOS {help}",
  "admin.noAvailableData": "Δεν υπάρχουν διαθέσιμα στοιχεία.",
  "admin.recentRoutes": "Πρόσφατες διαδρομές",
  "admin.recentRoutesDeferred": "Η admin ανάγνωση ιδιωτικών διαδρομών μένει για επόμενο ασφαλές στάδιο.",
  "admin.recentRoutesDeferredBody": "Δεν εμφανίζονται πλήρεις ιδιωτικές διαδρομές σε αυτό το βήμα.",
  "admin.usersPermissionTitle": "Δεν έχεις δικαίωμα προβολής χρηστών.",
  "admin.usersPermissionBody": "Η ανάγνωση της καρτέλας χρήστη δεν επιτρέπεται με τα τρέχοντα δικαιώματα.",
  "admin.livePermissionDenied": "Δεν επιτρέπεται η προβολή live στοιχείων για αυτόν τον χρήστη.",
  "admin.userNotFoundTitle": "Ο χρήστης δεν βρέθηκε",
  "admin.userNotFoundBody": "Δεν υπάρχει καρτέλα χρήστη για αυτό το ID.",
  "admin.backToAdmin": "Πίσω στο Admin",
  "admin.noUsers": "Δεν υπάρχουν διαθέσιμα user summaries.",
  "admin.usersUnavailable": "Η ανάγνωση χρηστών δεν ήταν διαθέσιμη με τα τρέχοντα rules.",
  "admin.userStatusActive": "ενεργός",
  "admin.lastSeen": "Τελευταία παρουσία",
  "admin.systemTitle": "Κατάσταση συστήματος",
  "admin.systemDescription": "Σύνδεσμοι ελέγχου για Web V2, public pages και Android App Links.",
  "admin.policy": "Πολιτική",
  "admin.systemServices": "Υπηρεσίες",
  "admin.participants": "συμμετέχοντες",
  "admin.statusDraft": "Πρόχειρο",
  "admin.statusUpcoming": "Προσεχώς",
  "admin.statusOngoing": "Σε εξέλιξη",
  "admin.statusCompleted": "Ολοκληρώθηκε",
  "admin.statusCancelled": "Ακυρώθηκε",
  "admin.statusDeleted": "Διαγραμμένη",
  "admin.eventTypeRace": "Αγώνας",
  "admin.eventTypeGroupRide": "Βόλτα",
  "admin.eventTypeTraining": "Προπόνηση",
  "admin.eventTypeCharity": "Φιλανθρωπική",
  "admin.eventTypeTour": "Περιήγηση",
  "admin.eventTypeOther": "Άλλη δράση",

  "actions.title": "Ενέργειες",
  "actions.subtitle": "Προσωπικό inbox για προσκλήσεις, support/control και SOS / Βοήθεια.",
  "actions.authSubtitle": "Προσκλήσεις, support/control και SOS χρειάζονται σύνδεση.",
  "actions.authBody": "Συνδέσου για να δεις τις προσωπικές εκκρεμότητες PULS.",
  "actions.pending": "Εκκρεμότητες",
  "actions.loadingAccount": "Φόρτωση λογαριασμού",
  "actions.loadingAccountBody": "Γίνεται έλεγχος σύνδεσης.",
  "actions.loadingInboxBody": "Γίνεται ανάγνωση των εκκρεμοτήτων.",
  "actions.loadError": "Δεν ήταν δυνατή η φόρτωση",
  "actions.emptyTitle": "Καμία εκκρεμότητα",
  "actions.invitationsTitle": "Προσκλήσεις αθλητή",
  "actions.invitationsSubtitle": "Προσκλήσεις για συμμετοχή σε Δράσεις.",
  "actions.invitationsEmpty": "Δεν υπάρχουν προσκλήσεις αθλητή σε αναμονή.",
  "actions.supportTitle": "Υποστήριξη / Control",
  "actions.supportSubtitle": "Αιτήματα ρόλου από διοργανωτές.",
  "actions.supportEmpty": "Δεν υπάρχουν support/control αιτήματα σε αναμονή.",
  "actions.helpTitle": "SOS / Βοήθεια",
  "actions.helpSubtitle": "Ανοιχτά αιτήματα που έχουν ανατεθεί στον λογαριασμό σου.",
  "actions.helpEmpty": "Δεν υπάρχουν ανοιχτά SOS / αιτήματα βοήθειας.",
  "actions.accept": "Αποδοχή",
  "actions.decline": "Απόρριψη",
  "actions.resolve": "Ολοκλήρωση",
  "actions.openAction": "Άνοιγμα δράσης",
  "actions.fromOrganizer": "Πρόσκληση από",
  "actions.organizer": "διοργανωτή",
  "actions.recipient": "Παραλήπτης",
  "actions.currentUser": "τρέχων χρήστης",
  "actions.created": "Δημιουργία",
  "actions.supportRequest": "Ο διοργανωτής {organizer} ζητά να αναλάβεις ρόλο {role}.",
  "actions.from": "Από",
  "actions.athlete": "Αθλητής",
  "actions.invitationAccepted": "Η πρόσκληση έγινε αποδεκτή.",
  "actions.invitationDeclined": "Η πρόσκληση απορρίφθηκε.",
  "actions.requestAccepted": "Το αίτημα έγινε αποδεκτό.",
  "actions.requestDeclined": "Το αίτημα απορρίφθηκε.",
  "actions.helpResolved": "Το SOS / αίτημα βοήθειας σημάνθηκε ως αντιμετωπισμένο.",
  "actions.errorGeneric": "Δεν ήταν δυνατή η ολοκλήρωση της ενέργειας.",
  "actions.errorPermission": "Δεν έχεις δικαίωμα για αυτή την ενέργεια.",
  "actions.errorIndex": "Η αναζήτηση χρειάζεται Firestore index. Η σελίδα παραμένει ασφαλής και δεν άλλαξε δεδομένα.",
  "actions.errorInvitationNotPending": "Η πρόσκληση δεν είναι πλέον σε αναμονή.",
  "actions.errorInvitationNoAccess": "Η πρόσκληση δεν ανήκει στον τρέχοντα χρήστη.",
  "actions.errorCyclistProfile": "Για Brevet χρειάζεται συμπληρωμένος αριθμός μητρώου αθλητή στο προφίλ.",
  "actions.errorEventFull": "Η δράση έχει συμπληρώσει το όριο συμμετοχών.",
  "actions.errorRequestNotPending": "Το αίτημα δεν είναι πλέον σε αναμονή.",
  "actions.errorRequestNoAccess": "Το αίτημα δεν ανήκει στον τρέχοντα χρήστη.",

  "status.pending": "Σε αναμονή",
  "status.accepted": "Αποδοχή",
  "status.declined": "Απόρριψη",
  "status.expired": "Έληξε",
  "status.open": "Ανοιχτό",
  "status.resolved": "Αντιμετωπίστηκε",

  "role.support": "Υποστήριξη",
  "role.control": "Control",
  "role.organizer": "Διοργανωτής",
  "role.organizer_pending": "Αίτημα διοργανωτή",
  "role.admin": "Admin",
  "role.cyclist": "Αθλητής",
  "help.withdrawal": "Αποχώρηση",

  "profile.title": "Προφίλ",
  "profile.subtitle": "Ο προσωπικός σου χώρος για δράσεις, διαδρομές, εκκρεμότητες και στοιχεία λογαριασμού.",
  "profile.loading": "Φόρτωση προφίλ",
  "profile.loadingBody": "Γίνεται ανάγνωση των στοιχείων του λογαριασμού σου.",
  "profile.signInRequired": "Σύνδεση για να δεις το προφίλ σου",
  "profile.signInRequiredBody": "Το προφίλ εμφανίζει μόνο τα δικά σου ασφαλή στοιχεία, διαδρομές και εκκρεμότητες.",
  "profile.defaultName": "Αθλητής PULS",
  "profile.myCard": "Η καρτέλα μου",
  "profile.myCardBody": "Βασικά στοιχεία από τον δικό σου λογαριασμό.",
  "profile.displayName": "Όνομα",
  "profile.settingsTitle": "Ρυθμίσεις προφίλ",
  "profile.settingsBody": "Ενημέρωσε τα δημόσια ασφαλή στοιχεία που εμφανίζονται στο PULS.",
  "profile.displayNameLabel": "Εμφανιζόμενο όνομα",
  "profile.photoUrlLabel": "Φωτογραφία προφίλ",
  "profile.changePhoto": "Αλλαγή φωτογραφίας",
  "profile.deletePhoto": "Διαγραφή φωτογραφίας",
  "profile.choosePhotoFile": "Επιλογή αρχείου",
  "profile.uploadingPhoto": "Ανέβασμα φωτογραφίας...",
  "profile.photoUpdated": "Η φωτογραφία ενημερώθηκε.",
  "profile.photoDeleted": "Η φωτογραφία διαγράφηκε.",
  "profile.photoUploadError": "Δεν ήταν δυνατή η αποστολή φωτογραφίας.",
  "profile.photoDeleteError": "Δεν ήταν δυνατή η διαγραφή της φωτογραφίας.",
  "profile.invalidPhotoFile": "Επίλεξε εικόνα JPG, PNG ή WebP έως 5MB.",
  "profile.photoHiddenHelp": "Η φωτογραφία ανεβαίνει στο PULS και το URL δεν εμφανίζεται σαν κείμενο στο προφίλ.",
  "profile.saveProfile": "Αποθήκευση προφίλ",
  "profile.profileUpdated": "Το προφίλ ενημερώθηκε.",
  "profile.profileSaveError": "Δεν ήταν δυνατή η αποθήκευση του προφίλ.",
  "profile.profilePermissionError": "Δεν έχεις δικαίωμα αλλαγής αυτών των στοιχείων.",
  "profile.privacyVisibility": "Απόρρητο και ορατότητα",
  "profile.privacyVisibilityBody": "Έλεγχοι για το τι εμφανίζεται στη δημόσια καρτέλα προφίλ.",
  "profile.publicProfile": "Δημόσιο προφίλ",
  "profile.publicProfileBody": "Ενεργοποιεί τη δημόσια καρτέλα σου στο puls.gr.",
  "profile.showPerformancePublicly": "Εμφάνιση επιδόσεων δημόσια",
  "profile.showPerformancePubliclyBody": "Δηλώνει ότι θέλεις να εμφανιστούν μόνο public-safe στατιστικά όταν υπάρχει διαθέσιμο public μοντέλο.",
  "profile.showRoutesPublicly": "Εμφάνιση διαδρομών δημόσια",
  "profile.showRoutesPubliclyBody": "Δηλώνει ότι θέλεις δημόσιες διαδρομές όταν ενεργοποιηθεί ασφαλές public mirror.",
  "profile.enablePublicProfileFirst": "Ενεργοποίησε πρώτα το δημόσιο προφίλ για να επιλέξεις δημόσιες ενότητες.",
  "profile.publicProfileLink": "Σύνδεσμος δημόσιου προφίλ",
  "profile.copyProfileLink": "Αντιγραφή συνδέσμου",
  "profile.profileLinkCopied": "Ο σύνδεσμος αντιγράφηκε",
  "profile.publicProfileLoading": "Γίνεται ανάγνωση της δημόσιας καρτέλας.",
  "profile.publicProfileUnavailable": "Το δημόσιο προφίλ δεν είναι διαθέσιμο.",
  "profile.publicProfileUnavailableBody": "Ο χρήστης δεν έχει ενεργοποιήσει δημόσιο προφίλ ή ο σύνδεσμος δεν είναι σωστός.",
  "profile.publicAthleteCard": "Δημόσια καρτέλα αθλητή",
  "profile.publicStatsPlaceholder": "Τα δημόσια στατιστικά θα εμφανιστούν όταν υπάρχουν διαθέσιμα public δεδομένα.",
  "profile.publicRoutesDeferred": "Οι δημόσιες διαδρομές θα ενεργοποιηθούν σε επόμενο βήμα.",
  "profile.preferredLanguage": "Προτιμώμενη γλώσσα",
  "profile.localLanguageSetting": "Τοπική ρύθμιση γλώσσας σε αυτόν τον browser.",
  "profile.futureOption": "Θα ενεργοποιηθεί σε επόμενο βήμα.",
  "profile.liveSharingVisibility": "Η ζωντανή κοινοποίηση είναι ορατή σε όσους έχουν τον σύνδεσμο.",
  "profile.resultsVisibilityNote": "Τα αποτελέσματα δράσεων μπορεί να εμφανίζονται δημόσια με ασφαλή στοιχεία.",
  "profile.email": "Email",
  "profile.providers": "Πάροχος σύνδεσης",
  "profile.language": "Γλώσσα",
  "profile.roles": "Ρόλοι",
  "profile.rolesBody": "Οι ρόλοι προκύπτουν από τον λογαριασμό και τις δράσεις σου.",
  "profile.myActions": "Οι δράσεις μου",
  "profile.myActionsBody": "Δράσεις όπου είσαι διοργανωτής, συμμετέχων, υποστήριξη ή control.",
  "profile.openActions": "Άνοιγμα δράσεων",
  "profile.myRoutes": "Οι διαδρομές μου",
  "profile.myRoutesBody": "Πρόσφατες αποθηκευμένες και εισηγμένες διαδρομές.",
  "profile.openRoutes": "Άνοιγμα διαδρομών",
  "profile.openRouteEditor": "Επεξεργασία / Δημιουργία",
  "profile.myTasks": "Οι ενέργειές μου",
  "profile.myTasksBody": "Εκκρεμότητες από προσκλήσεις, support/control και SOS.",
  "profile.openTasks": "Άνοιγμα ενεργειών",
  "profile.myPerformance": "Οι επιδόσεις μου",
  "profile.myPerformanceBody": "Πραγματικά προσωπικά στατιστικά από τις αποθηκευμένες διαδρομές σου.",
  "profile.performanceFilter": "Φίλτρο επιδόσεων",
  "profile.filterAll": "Όλες",
  "profile.profileBicycle": "Ποδήλατο",
  "profile.profileElectricBike": "Ηλεκτρικό ποδήλατο",
  "profile.profileHiking": "Πεζοπορία",
  "profile.profileMotorVehicle": "Μηχανοκίνητο",
  "profile.profileOther": "Άλλο / παλιές",
  "profile.totalRoutes": "Διαδρομές",
  "profile.totalTime": "Συνολικός χρόνος",
  "profile.averageSpeed": "Μέση ταχύτητα",
  "profile.maxSpeed": "Μέγιστη ταχύτητα",
  "profile.distanceByMonth": "Απόσταση ανά μήνα",
  "profile.elevationByMonth": "Υψομετρικά ανά μήνα",
  "profile.activitiesByMonth": "Δραστηριότητες ανά μήνα",
  "profile.personalRecords": "Προσωπικά ρεκόρ",
  "profile.mostElevation": "Περισσότερα υψομετρικά",
  "profile.bestAverageSpeed": "Καλύτερη μέση ταχύτητα",
  "profile.longestDuration": "Μεγαλύτερη διάρκεια",
  "profile.recentActivities": "Πρόσφατες δραστηριότητες",
  "profile.openRecord": "Άνοιγμα",
  "profile.noPerformanceData": "Δεν υπάρχουν δεδομένα για αυτό το φίλτρο.",
  "profile.privacyAccount": "Απόρρητο και λογαριασμός",
  "profile.privacyBody": "Σύνδεσμοι για πολιτική απορρήτου και διαγραφή λογαριασμού.",
  "profile.publicLinksNote": "Οι δημόσιοι live σύνδεσμοι είναι ορατοί σε όποιον έχει τον σύνδεσμο.",
  "profile.privacyPolicy": "Πολιτική απορρήτου",
  "profile.accountDeletion": "Διαγραφή λογαριασμού",
  "profile.recentRoutes": "Πρόσφατες διαδρομές",
  "profile.pending": "Εκκρεμότητες",
  "profile.totalDistance": "Σύνολο απόστασης",
  "profile.longestRoute": "Μεγαλύτερη διαδρομή",
  "profile.totalElevation": "Συνολικά υψομετρικά",
  "profile.recentActivity": "Πρόσφατη δραστηριότητα",
  "profile.noData": "Δεν υπάρχουν δεδομένα ακόμη",
  "profile.invitations": "Προσκλήσεις",
  "profile.supportControl": "Support / Control",
  "profile.helpSos": "SOS / Βοήθεια",
  "profile.profileLoadError": "Δεν ήταν δυνατή η φόρτωση της καρτέλας σου.",
  "profile.routesLoadError": "Δεν ήταν δυνατή η φόρτωση των διαδρομών σου.",
  "profile.actionsLoadError": "Δεν ήταν δυνατή η φόρτωση των δράσεών σου.",
  "profile.pendingLoadError": "Δεν ήταν δυνατή η φόρτωση των εκκρεμοτήτων.",
  "profile.readOnlyProfile": "Η επεξεργασία προφίλ θα προστεθεί ξεχωριστά όταν κλειδώσει το ασφαλές μοντέλο εγγραφής.",

  "events.title": "Δράσεις",
  "events.myTitle": "Οι δράσεις μου",
  "events.subtitle": "Δημόσια προβολή δράσεων. Η συμμετοχή ελέγχεται από τον τρόπο συμμετοχής, όχι από την προβολή.",
  "events.mySubtitle": "Μόνο οι δράσεις όπου είσαι διοργανωτής, συμμετέχων, support ή control.",
  "events.newAction": "Νέα Δράση",
  "events.invitationsRequests": "Προσκλήσεις & αιτήματα",
  "events.loadingTitle": "Φόρτωση δράσεων",
  "events.loadingPublic": "Γίνεται ανάγνωση των δημόσιων δράσεων.",
  "events.loadingMine": "Γίνεται ανάγνωση των δικών σου δράσεων.",
  "events.loadErrorTitle": "Δεν ήταν δυνατή η φόρτωση",
  "events.loadErrorBody": "Δοκίμασε ξανά σε λίγο. Η σελίδα δεν τροποποιεί δεδομένα.",
  "events.emptyPublicTitle": "Δεν υπάρχουν διαθέσιμες δράσεις",
  "events.emptyMineTitle": "Δεν υπάρχουν δικές σου δράσεις",
  "events.emptyPublicBody": "Οι διαγραμμένες, πρόχειρες ή ακυρωμένες δράσεις δεν εμφανίζονται στη δημόσια λίστα.",
  "events.emptyMineBody": "Όταν είσαι διοργανωτής, συμμετέχων, support ή control σε δράση, θα εμφανιστεί εδώ.",
  "events.photo": "Φωτογραφία δράσης",
  "events.noLocation": "Δεν έχει δηλωθεί τοποθεσία",
  "events.registrationDeadline": "Προθεσμία",
  "events.untilStart": "έως την έναρξη",
  "events.participants": "συμμετέχοντες",

  "routes.title": "Οι διαδρομές μου",
  "routes.subtitle": "Συγχρονισμένες διαδρομές από την εφαρμογή, μαζί με εισηγμένες διαδρομές κοινότητας.",
  "routes.authSubtitle": "Προσωπικές και εισηγμένες διαδρομές από την εφαρμογή.",
  "routes.count": "{count} διαδρομές",
  "routes.loadingAccount": "Έλεγχος σύνδεσης",
  "routes.loadingAccountBody": "Γίνεται ανάγνωση του λογαριασμού.",
  "routes.signInRequired": "Απαιτείται σύνδεση",
  "routes.signInRequiredBody": "Συνδέσου για να δεις τις αποθηκευμένες διαδρομές σου.",
  "routes.loadingTitle": "Φόρτωση διαδρομών",
  "routes.loadingBody": "Γίνεται ανάγνωση από το προσωπικό Firestore sync.",
  "routes.loadErrorTitle": "Δεν ήταν δυνατή η φόρτωση",
  "routes.loadErrorBody": "Έλεγξε ότι είσαι συνδεδεμένος με τον ίδιο λογαριασμό που χρησιμοποιεί η εφαρμογή.",
  "routes.emptyTitle": "Δεν υπάρχουν συγχρονισμένες διαδρομές",
  "routes.emptyBody": "Οι διαδρομές εμφανίζονται εδώ αφού αποθηκευτούν/συγχρονιστούν από την Android εφαρμογή ή τον web editor.",
  "routes.recordedSection": "Καταγραφές από την εφαρμογή",
  "routes.importedSection": "Εισηγμένες διαδρομές",
  "routes.imported": "Εισηγμένη",
  "routes.own": "Δική μου",
  "routes.points": "σημεία",
  "routes.routePoints": "σημεία διαδρομής",
  "routes.profileBicycle": "Ποδήλατο",
  "routes.profileElectricBike": "Ηλεκτρικό ποδήλατο",
  "routes.profileHiking": "Περπάτημα / πεζοπορία",
  "routes.profileMotorVehicle": "Μηχανοκίνητο",
  "routes.profileLegacy": "Legacy / χωρίς προφίλ",

  "detail.actionDetails": "Λεπτομέρειες δράσης",
  "detail.publicAction": "Δημόσια προβολή δράσης.",
  "detail.legacyAction": "Συμβατός σύνδεσμος /event/:eventId στο νέο Web V2.",
  "detail.participants": "Συμμετέχοντες",
  "detail.invitations": "Προσκλήσεις",
  "detail.supportControl": "Υποστήριξη / Control",
  "detail.results": "Αποτελέσματα",
  "detail.editRoute": "Επεξεργασία διαδρομής",
  "detail.editAction": "Επεξεργασία Δράσης",
  "detail.useSavedRoute": "Επιλογή από Διαδρομές μου",

  "public.live": "Live",
  "public.inactive": "Ανενεργό",
  "public.stale": "Stale",
  "public.speed": "Ταχύτητα",
  "public.average": "Μέση",
  "public.max": "Μέγιστη",
  "public.distance": "Απόσταση",
  "public.duration": "Χρόνος",
  "public.elevation": "Υψομετρικά",
  "public.altitude": "Υψόμετρο",
  "public.points": "Σημεία",
  "public.lastUpdate": "Τελευταία ενημέρωση",
  "public.liveMap": "Live χάρτης",
  "public.missingLink": "Ο σύνδεσμος δεν είναι πλήρης",
  "public.missingEvent": "Δεν υπάρχει αναγνωριστικό δράσης στον σύνδεσμο.",
  "public.missingSession": "Δεν υπάρχει αναγνωριστικό live session στον σύνδεσμο.",
  "public.trackShareTools": "Κοινοποίηση ζωντανής τοποθεσίας",
  "public.trackShareToolsBody": "Αντιγραφή ασφαλούς κειμένου ή social link με preview, χωρίς ακριβείς συντεταγμένες.",
  "public.trackShareTitle": "📍 Ζωντανή τοποθεσία PULS",
  "public.trackShareBody": "Ο/Η {name} κοινοποιεί ζωντανά την τοποθεσία του/της.",
  "public.trackShareOpen": "Άνοιξε την παρακολούθηση:",
  "public.trackShareDownload": "Κατέβασε την εφαρμογή PULS:",

  "liveControl.title": "Live Race Control Room",
  "liveControl.publicAccess": "Δημόσια προβολή",
  "liveControl.signedInAccess": "Συνδεδεμένος χρήστης",
  "liveControl.checkingAccess": "Έλεγχος πρόσβασης",
  "liveControl.adminAccess": "Admin control room",
  "liveControl.organizerAccess": "Διοργανωτής",
  "liveControl.supportAccess": "Υποστήριξη",
  "liveControl.controlAccess": "Control",
  "liveControl.privateDeniedTitle": "Ιδιωτικό control room",
  "liveControl.privateDeniedBody": "Η ιδιωτική λίστα live athletes απαιτεί πρόσβαση διοργανωτή/support/control. Η δημόσια προβολή συνεχίζει από το public live mirror.",
  "liveControl.noMirrorTitle": "Δεν υπάρχει ακόμα δημόσιο live mirror",
  "liveControl.noMirrorBody": "Η δράση φορτώθηκε από Firestore, αλλά δεν υπάρχουν ακόμα live athletes στο public RTDB mirror.",
  "liveControl.closedTitle": "Το live tracking έχει ολοκληρωθεί",
  "liveControl.closedBody": "Η διοργάνωση έχει λήξει ή ακυρωθεί, οπότε δεν εμφανίζονται πλέον στίγματα αθλητών.",
  "liveControl.publicLoadError": "Το public live event δεν μπόρεσε να διαβαστεί. Δεν έγινε καμία αλλαγή σε δεδομένα.",
  "liveControl.totalAthletes": "Σύνολο αθλητών",
  "liveControl.liveAthletes": "Live αθλητές",
  "liveControl.staleAthletes": "Καθυστέρηση",
  "liveControl.openHelp": "Ανοιχτά SOS",
  "liveControl.located": "με στίγμα",
  "liveControl.athletes": "Αθλητές",
  "liveControl.athletesBody": "Αναζήτηση, φίλτρα και εστίαση στον χάρτη.",
  "liveControl.searchAthlete": "Αναζήτηση ονόματος ή αριθμού",
  "liveControl.filterALL": "Όλοι",
  "liveControl.filterLIVE": "Live",
  "liveControl.filterSTALE": "Καθυστέρηση",
  "liveControl.filterSOS": "SOS",
  "liveControl.filterDONE": "Τερμάτισαν / Αποχώρησαν",
  "liveControl.noAthletes": "Δεν υπάρχουν αθλητές για αυτό το φίλτρο.",
  "liveControl.live": "Live",
  "liveControl.stale": "Καθυστέρηση",
  "liveControl.offline": "Offline",
  "liveControl.paused": "Παύση",
  "liveControl.finished": "Τερμάτισε",
  "liveControl.withdrawn": "Αποχώρησε",
  "liveControl.battery": "Μπαταρία",
  "liveControl.hasHelp": "SOS / Βοήθεια",
  "liveControl.mapTitle": "Live χάρτης ελέγχου",
  "liveControl.mapBody": "Αθλητές, διαδρομή και σημεία Roadbook σε έναν χάρτη.",
  "liveControl.mapLoadError": "Ο χάρτης δεν ήταν δυνατό να φορτωθεί.",
  "liveControl.followingAthlete": "Εστίαση: {name}",
  "liveControl.athleteNotFound": "Ο αθλητής δεν βρέθηκε στο live αυτή τη στιγμή.",
  "liveControl.fitAll": "Όλοι στον χάρτη",
  "liveControl.clearSelection": "Καθαρισμός επιλογής",
  "liveControl.helpTitle": "SOS / Βοήθεια",
  "liveControl.helpBody": "Ανοιχτά αιτήματα που έχουν ανατεθεί σε εσένα.",
  "liveControl.helpPublicBody": "Τα λειτουργικά SOS εμφανίζονται μόνο σε διοργανωτή/support/control.",
  "liveControl.helpLoading": "Φόρτωση SOS / Βοήθεια...",
  "liveControl.helpError": "Δεν ήταν δυνατή η φόρτωση ή ενημέρωση SOS.",
  "liveControl.noHelp": "Δεν υπάρχουν ανοιχτά SOS / αιτήματα βοήθειας.",
  "liveControl.dataSourceTitle": "Πηγή δεδομένων",
  "liveControl.publicDataSource": "Η δημόσια προβολή βασίζεται στο public_live_events και δεν εμφανίζει ιδιωτικά στοιχεία.",
  "liveControl.operationalDataSource": "Το control room χρησιμοποιεί public live mirror και, όπου επιτρέπεται, ιδιωτική πρόσβαση live_events.",
  "liveControl.privacyTitle": "Privacy-safe",
  "liveControl.privacyBody": "Δεν εμφανίζονται τηλέφωνα, email, emergency fields ή raw user ids.",
  "liveControl.doneSummary": "{count} αθλητές έχουν τερματίσει ή αποχωρήσει.",

  "routeEditor.title": "Επεξεργασία / Δημιουργία διαδρομής",
  "routeEditor.import": "Εισαγωγή αρχείου",
  "routeEditor.routeMode": "Διαδρομή",
  "routeEditor.poiMode": "Σημεία ενδιαφέροντος",
  "routeEditor.start": "Εκκίνηση",
  "routeEditor.finish": "Τερματισμός",
  "routeEditor.waypoint": "Ενδιάμεσο σημείο",
  "routeEditor.save": "Αποθήκευση",
  "routeEditor.update": "Ενημέρωση διαδρομής",
  "routeEditor.copy": "Αποθήκευση αντιγράφου",
  "routeEditor.undo": "Αναίρεση",
  "routeEditor.clear": "Καθαρισμός",
  "routeEditor.discard": "Απόρριψη",
  "routeEditor.draftRecovery": "Ανάκτηση πρόχειρου",
  "routeEditor.collapseTools": "Σύμπτυξη εργαλείων",
  "routeEditor.openTools": "Άνοιγμα εργαλείων",
  "routeEditor.fullMap": "Πλήρης χάρτης",
  "routeEditor.showTools": "Εμφάνιση εργαλείων",
  "routeEditor.shortcuts": "Συντομεύσεις",
  "routeEditor.shortcutsHint": "Συντομεύσεις: Ctrl+Z αναίρεση, Esc ακύρωση εργαλείου.",
  "routeEditor.cancelTool": "Ακύρωση εργαλείου",
  "routeEditor.sectionImport": "Εισαγωγή αρχείου",
  "routeEditor.sectionRoute": "Διαδρομή",
  "routeEditor.sectionCorrection": "Εργαλεία διόρθωσης",
  "routeEditor.sectionMarkers": "Σημεία διαδρομής",
  "routeEditor.sectionRoadbook": "Roadbook",
  "routeEditor.sectionSave": "Αποθήκευση",
  "routeEditor.kmTools": "Εργαλεία χιλιομέτρων",
  "routeEditor.type": "Τύπος",
  "routeEditor.titleField": "Τίτλος",
  "routeEditor.descriptionField": "Περιγραφή",
  "routeEditor.moveToKm": "Μετακίνηση στο km",
  "routeEditor.visibleToAthletes": "Ορατό στους αθλητές",
  "routeEditor.localMarkers": "local markers στο workspace",
  "routeEditor.kmAutoHint": "Το km ενημερώνεται αυτόματα όταν το σημείο μπαίνει κοντά στη διαδρομή.",
  "routeEditor.correctionTools": "Εργαλεία διόρθωσης",
  "routeEditor.correctionToolsHint": "Αντιστροφή, κόψιμο ή ασφαλής καθαρισμός της γραμμής πριν την αποθήκευση.",
  "routeEditor.reverseRoute": "Αντιστροφή διαδρομής",
  "routeEditor.trimStart": "Κόψιμο αρχής",
  "routeEditor.trimFinish": "Κόψιμο τέλους",
  "routeEditor.cleanRoute": "Καθαρισμός διαδρομής",
  "routeEditor.trimToolHint": "Πάτα πάνω στη διαδρομή για επιλογή σημείου.",
  "routeEditor.routeRequiredForCorrection": "Υπολόγισε ή εισήγαγε πρώτα διαδρομή.",
  "routeEditor.correctionRouteTooShort": "Η διαδρομή θα έμενε πολύ μικρή για διόρθωση.",
  "routeEditor.trimPointTooFar": "Το σημείο είναι μακριά από τη διαδρομή.",
  "routeEditor.routeReversed": "Η διαδρομή αντιστράφηκε.",
  "routeEditor.routeTrimmedStart": "Κόπηκε η αρχή της διαδρομής.",
  "routeEditor.routeTrimmedFinish": "Κόπηκε το τέλος της διαδρομής.",
  "routeEditor.routeCleaned": "Καθαρίστηκε η διαδρομή. Αφαιρέθηκαν {count} σημεία.",
  "routeEditor.routeAlreadyClean": "Δεν βρέθηκαν προβληματικά σημεία για καθαρισμό.",
  "routeEditor.markerFarWarning": "Κάποια σημεία ενδιαφέροντος είναι μακριά από τη νέα διαδρομή.",
  "routeEditor.unifiedSearchLabel": "Αναζήτηση",
  "routeEditor.unifiedSearchPlaceholder": "Αναζήτηση τοποθεσίας ή σημείου διαδρομής",
  "routeEditor.placesGroup": "Τοποθεσίες",
  "routeEditor.routePointsGroup": "Σημεία διαδρομής",
  "routeEditor.noSearchResults": "Δεν βρέθηκαν αποτελέσματα",
  "routeEditor.selectTargetFirst": "Επίλεξε πρώτα στόχο για την τοποθεσία",
  "routeEditor.target": "Στόχος",
  "routeEditor.placesMinChars": "Οι προτάσεις τοποθεσιών εμφανίζονται μετά από 5 χαρακτήρες.",
  "routeEditor.placesLoading": "Φόρτωση προτάσεων...",
  "routeEditor.placeSelectError": "Δεν ήταν δυνατή η επιλογή της τοποθεσίας.",
  "routeEditor.markerListHint": "Τα σημεία φιλτράρονται από την κοινή αναζήτηση επάνω.",
  "routeEditor.routePointSuggestions": "Προτάσεις σημείων",
  "routeEditor.elevationCalculating": "Υπολογισμός υψομετρικών...",
  "routeEditor.elevationFailed": "Δεν ήταν δυνατός ο υπολογισμός υψομετρικών.",
  "routeEditor.elevationRetry": "Δοκιμή ξανά",
  "routeEditor.saveWithoutElevation": "Αποθήκευση χωρίς υψομετρικά",
  "routeEditor.exportGpx": "Εξαγωγή GPX",
  "routeEditor.gpxCreating": "Δημιουργία GPX...",
  "routeEditor.noRouteToExport": "Δεν υπάρχει διαδρομή για εξαγωγή.",
  "routeEditor.gpxExportSuccess": "Το GPX δημιουργήθηκε για λήψη.",
  "routeEditor.gpxExportFailed": "Δεν ήταν δυνατή η εξαγωγή GPX.",
  "routeEditor.noElevationWarning": "Η διαδρομή δεν έχει υψομετρικά.",
  "routeEditor.exportWithoutElevationHint": "Αποθήκευσε πρώτα για υπολογισμό υψομετρικών ή εξήγαγε χωρίς υψομετρικά.",
  "routeEditor.exportWithoutElevation": "Εξαγωγή χωρίς υψομετρικά",
  "routeEditor.gpxIncludesElevation": "Η εξαγωγή GPX περιλαμβάνει υψομετρικά.",
  "routeEditor.saveSuccessWithTime": "Αποθηκεύτηκε επιτυχώς. Τελευταία αποθήκευση: {time}",
  "routeEditor.saveFailed": "Δεν ήταν δυνατή η αποθήκευση της διαδρομής.",
  "routeEditor.updateFailed": "Δεν ήταν δυνατή η ενημέρωση της διαδρομής.",

  "common.close": "Κλείσιμο",
  "common.points": "σημεία",
  "common.routePoints": "σημεία διαδρομής",
  "common.saving": "Αποθήκευση...",
  "common.replacing": "Αντικατάσταση",
  "common.unknown": "Άγνωστο",

  "eventType.BREVET": "Brevet",
  "eventType.RACE": "Αγώνας",
  "eventType.GROUPRIDE": "Βόλτα",
  "eventType.TRAINING": "Προπόνηση",
  "eventType.CHARITY": "Φιλανθρωπική",
  "eventType.TOUR": "Περιήγηση",
  "eventType.OTHER": "Άλλη δράση",
  "eventStatus.UPCOMING": "Προσεχώς",
  "eventStatus.ONGOING": "Σε εξέλιξη",
  "eventStatus.COMPLETED": "Ολοκληρώθηκε",
  "eventStatus.DRAFT": "Πρόχειρο",
  "eventStatus.CANCELLED": "Ακυρώθηκε",
  "eventStatus.CANCELED": "Ακυρώθηκε",
  "participationMode.OPEN": "Ανοιχτή συμμετοχή",
  "participationMode.APPROVAL_REQUIRED": "Με έγκριση",
  "participationMode.INVITE_ONLY": "Με πρόσκληση",

  "preview.defaultTitle": "Προεπισκόπηση",
  "preview.actionPhoto": "Φωτογραφία δράσης",
  "preview.noVisual": "Δεν υπάρχει ακόμη διαθέσιμη φωτογραφία ή προεπισκόπηση διαδρομής.",

  "routeMarkers.title": "Σημεία διαδρομής",
  "routeMarkers.emptyPublic": "Δεν έχουν προστεθεί δημόσια σημεία διαδρομής.",
  "routeMarkers.loading": "Φόρτωση σημείων διαδρομής...",
  "routeMarkers.loadError": "Δεν ήταν δυνατή η φόρτωση των σημείων διαδρομής.",
  "routeMarkers.pointOfInterest": "Σημείο ενδιαφέροντος",

  "elevationProfile.title": "Υψομετρικό προφίλ",
  "elevationProfile.notEnoughData": "Δεν υπάρχουν αρκετά σημεία με υψόμετρο για γράφημα.",

  "savedRoute.mapTitle": "Χάρτης διαδρομής",
  "savedRoute.mapDescription": "Πλήρης προβολή της διαδρομής με εκκίνηση, τερματισμό και σημεία ενδιαφέροντος.",
  "savedRoute.largeMap": "Μεγάλος χάρτης",
  "savedRoute.largeMapDescription": "Μεγάλος χάρτης διαδρομής.",
  "savedRoute.mapLoadError": "Ο χάρτης δεν ήταν δυνατό να φορτωθεί. Η διαδρομή εμφανίζεται σε απλό preview.",
  "savedRoute.routeHighlightsTitle": "Σημεία διαδρομής",
  "savedRoute.routeHighlightsBody": "Σημαντικά σημεία από την αποθηκευμένη καταγραφή.",
  "savedRoute.noRouteHighlights": "Δεν υπάρχουν αρκετά δεδομένα για σημαντικά σημεία.",
  "savedRoute.maxSpeedPoint": "Μέγιστη ταχύτητα",
  "savedRoute.maxAltitudePoint": "Μεγαλύτερο υψόμετρο",
  "savedRoute.focusMap": "Εστίαση στον χάρτη",
  "savedRoute.kmAlongRoute": "Km διαδρομής",
  "savedRoute.time": "Χρόνος",
  "savedRoute.altitude": "Υψόμετρο",
  "savedRoute.climbsTitle": "Πιθανές αναβάσεις",
  "savedRoute.climbsBody": "Τοπική ανίχνευση ανάβασης με λογική αντίστοιχη της Android εφαρμογής.",
  "savedRoute.climbsCount": "{count} πιθανές",
  "savedRoute.climbLabel": "Πιθανή ανάβαση {index}",
  "savedRoute.viewOnMap": "Προβολή στον χάρτη",
  "savedRoute.noClimbs": "Δεν εντοπίστηκαν πιθανές αναβάσεις σε αυτή τη διαδρομή.",
  "savedRoute.climbsUnsupported": "Η ανίχνευση αναβάσεων δεν εφαρμόζεται σε αυτόν τον τύπο διαδρομής.",
  "savedRoute.from": "Από",
  "savedRoute.to": "Έως",
  "savedRoute.elevationGain": "Υψομετρική ανάβαση",
  "savedRoute.averageGrade": "Μέση κλίση",
  "savedRoute.climbStart": "Αρχή ανάβασης",
  "savedRoute.climbFinish": "Τέλος ανάβασης",
  "savedRoute.hours": "Ώρες",
  "savedRoute.water": "Νερό",
  "savedRoute.food": "Φαγητό",
  "savedRoute.coffee": "Στάση / Καφές",
  "savedRoute.warning": "Προσοχή",
  "savedRoute.service": "Service",
  "savedRoute.photo": "Φωτογραφία",
  "savedRoute.note": "Σημείωση",
  "savedRoute.personalDescription": "Προσωπική αποθηκευμένη διαδρομή από την εφαρμογή ή τον web editor.",
  "savedRoute.edit": "Επεξεργασία",
  "savedRoute.openInEditor": "Άνοιγμα στο Route Editor",
  "savedRoute.useInAction": "Χρήση σε Δράση",
  "savedRoute.downloadGpx": "Λήψη GPX",
  "savedRoute.missingTitle": "Λείπει η διαδρομή",
  "savedRoute.missingBody": "Ο σύνδεσμος δεν περιέχει ride id.",
  "savedRoute.loadingTitle": "Φόρτωση διαδρομής",
  "savedRoute.loadingBody": "Γίνεται ανάγνωση της προσωπικής διαδρομής.",
  "savedRoute.loadErrorTitle": "Δεν ήταν δυνατή η φόρτωση",
  "savedRoute.loadErrorBody": "Η διαδρομή δεν διαβάστηκε από το προσωπικό σου Firestore.",
  "savedRoute.notFoundTitle": "Η διαδρομή δεν βρέθηκε",
  "savedRoute.notFoundBody": "Μπορεί να έχει διαγραφεί ή να ανήκει σε άλλο λογαριασμό.",
  "savedRoute.authBody": "Συνδέσου για να δεις τις προσωπικές αποθηκευμένες διαδρομές σου.",
  "savedRoute.poiTitle": "Σημεία ενδιαφέροντος / control",
  "savedRoute.poiBody": "Τα σημεία που είναι αποθηκευμένα μαζί με τη διαδρομή.",
  "savedRoute.noPoi": "Δεν υπάρχουν αποθηκευμένα σημεία ενδιαφέροντος.",
  "savedRoute.activityChangeType": "Αλλαγή τύπου δραστηριότητας",
  "savedRoute.activityChangeTypeBody": "Επίλεξε τον σωστό τύπο χωρίς να αλλάξει η γεωμετρία, τα σημεία GPS ή τα στοιχεία της διαδρομής.",
  "savedRoute.activityExcludeFromRecords": "Εξαίρεση από προσωπικά ρεκόρ",
  "savedRoute.activityIncludeInRecords": "Συμμετοχή στα προσωπικά ρεκόρ",
  "savedRoute.activityExcludeConfirmBody": "Η διαδρομή θα παραμείνει αποθηκευμένη, αλλά δεν θα μετράει στα καλύτερά σου, στα personal records ή σε προσπάθειες τμημάτων.",
  "savedRoute.activityIncludeConfirmBody": "Η διαδρομή θα μπορεί να μετράει ξανά στα προσωπικά στατιστικά, εφόσον δεν παραμένει ύποπτη ή μη συμβατή με τον τύπο της.",
  "savedRoute.activitySuspiciousTitle": "Ύποπτη δραστηριότητα",
  "savedRoute.activitySuspiciousBody": "Η διαδρομή φαίνεται ασύμβατη με τον επιλεγμένο τύπο δραστηριότητας. Διόρθωσε τον τύπο ή εξαίρεσέ την από τα ρεκόρ.",
  "savedRoute.activityExcludedTitle": "Εκτός προσωπικών ρεκόρ",
  "savedRoute.activityExcludedBody": "Η διαδρομή παραμένει αποθηκευμένη, αλλά δεν μετράει στα καλύτερά σου ή στις προσπάθειες τμημάτων.",
  "savedRoute.activityKeepAsIs": "Να μείνει ως έχει",
  "savedRoute.activityTypeUpdated": "Ο τύπος δραστηριότητας ενημερώθηκε.",
  "savedRoute.activityExcludedFromRecords": "Η διαδρομή εξαιρέθηκε από τα ρεκόρ.",
  "savedRoute.activityIncludedInRecords": "Η διαδρομή μπορεί να μετράει ξανά στα ρεκόρ.",
  "savedRoute.activityKeptAsIs": "Η διαδρομή επιβεβαιώθηκε όπως είναι.",
  "savedRoute.activityUpdateFailed": "Δεν ήταν δυνατή η ενημέρωση της διαδρομής.",
  "savedRoute.activityFlagHikingSpeedHigh": "Η πεζοπορία έχει πολύ υψηλή ταχύτητα.",
  "savedRoute.activityFlagBicycleSpeedHigh": "Η ποδηλασία έχει ασυνήθιστα υψηλή ταχύτητα.",
  "savedRoute.activityFlagEbikeSpeedHigh": "Το ηλεκτρικό ποδήλατο έχει ασυνήθιστα υψηλή ταχύτητα.",
  "savedRoute.activityFlagCarLikeSpeed": "Η διαδρομή μοιάζει με μηχανοκίνητη μετακίνηση.",
  "savedRoute.activityFlagTeleportJump": "Υπάρχει πιθανό άλμα GPS ή μη ρεαλιστικό τμήμα.",
  "savedRoute.activityFlagGeneric": "Η διαδρομή χρειάζεται έλεγχο.",
  "savedRoute.stats": "Στατιστικά",
  "savedRoute.summary": "Σύνοψη σημείων διαδρομής",
  "savedRoute.routePoints": "Route points",
  "savedRoute.controlPoiPoints": "Control / POI points",
  "savedRoute.firstPoint": "Πρώτο σημείο",
  "savedRoute.lastPoint": "Τελευταίο σημείο",
  "savedRoute.file": "Αρχείο",
  "savedRoute.createSegment": "Δημιουργία τμήματος",
  "savedRoute.segmentCreateTitle": "Δημιουργία τμήματος από ανάβαση",
  "savedRoute.segmentCreateBody": "Διόρθωσε αρχή/τέλος, δώσε όνομα και αποθήκευσε το τμήμα στην Κοινότητα.",
  "savedRoute.defaultSegmentTitle": "Ανάβαση {from}-{to} km",
  "savedRoute.segmentName": "Όνομα τμήματος",
  "savedRoute.segmentDescription": "Περιγραφή",
  "savedRoute.segmentProfile": "Προφίλ",
  "savedRoute.segmentStartKm": "Αρχή (km)",
  "savedRoute.segmentFinishKm": "Τέλος (km)",
  "savedRoute.selectStartEndpoint": "Αλλαγή αρχής",
  "savedRoute.selectFinishEndpoint": "Αλλαγή τέλους",
  "savedRoute.endpointStart": "αρχή",
  "savedRoute.endpointFinish": "τέλος",
  "savedRoute.segmentAdjustHint": "Ενεργό σημείο: {endpoint}. Πάτησε πάνω στη μπλε γραμμή της διαδρομής ή άλλαξε τα km.",
  "savedRoute.segmentInvalidEndpoints": "Η αρχή πρέπει να είναι πριν από το τέλος και να έχει αρκετά σημεία διαδρομής.",
  "savedRoute.segmentTooShort": "Το τμήμα πρέπει να έχει μήκος τουλάχιστον 100 m.",
  "savedRoute.segmentTitleRequired": "Γράψε όνομα τμήματος.",
  "savedRoute.segmentUnsupportedProfile": "Αυτό το προφίλ δεν υποστηρίζεται για τμήματα.",
  "savedRoute.segmentSaving": "Αποθήκευση...",
  "savedRoute.saveSegment": "Αποθήκευση τμήματος",
  "savedRoute.segmentSaveSuccess": "Το τμήμα αποθηκεύτηκε και θα εμφανιστεί στα Τμήματα.",
  "savedRoute.segmentSaveFailed": "Δεν ήταν δυνατή η αποθήκευση του τμήματος.",
  "savedRoute.openSegments": "Άνοιγμα Τμημάτων",
  "stats.distance": "Απόσταση",
  "stats.duration": "Διάρκεια",
  "stats.average": "Μέση",
  "stats.max": "Μέγιστη",
  "stats.elevationGain": "Υψομετρικά +",
  "stats.elevationLoss": "Υψομετρικά -",
  "stats.minAltitude": "Min υψόμετρο",
  "stats.maxAltitude": "Max υψόμετρο",
  "stats.points": "Σημεία",

  "attachRoute.title": "Σύνδεση διαδρομής με δράση",
  "attachRoute.description": "Η διαδρομή θα ανέβει ως GPX και θα ενημερώσει την προεπισκόπηση της δράσης.",
  "attachRoute.chooseAction": "Επιλογή δράσης",
  "attachRoute.action": "Δράση",
  "attachRoute.chooseRoute": "Επιλογή διαδρομής",
  "attachRoute.route": "Διαδρομή",
  "attachRoute.loadingActions": "Φόρτωση δράσεων...",
  "attachRoute.loadingRoutes": "Φόρτωση διαδρομών...",
  "attachRoute.noEditableActions": "Δεν βρέθηκαν δράσεις που μπορείς να επεξεργαστείς.",
  "attachRoute.noRoutes": "Δεν βρέθηκαν αποθηκευμένες διαδρομές με έγκυρα σημεία.",
  "attachRoute.replaceWarning": "Η δράση έχει ήδη διαδρομή. Θέλω να την αντικαταστήσω με την επιλεγμένη διαδρομή.",
  "attachRoute.transferMarkers": "Μεταφορά σημείων διαδρομής στη δράση",
  "attachRoute.transferMarkersAvailable": "προσθήκη χωρίς διαγραφή υπαρχόντων",
  "attachRoute.transferMarkersUnavailable": "δεν υπάρχουν σημεία στη διαδρομή",
  "attachRoute.submit": "Σύνδεση διαδρομής",
  "attachRoute.submitting": "Σύνδεση...",
  "attachRoute.success": "Η διαδρομή συνδέθηκε με τη δράση.",
  "attachRoute.successWithMarkers": "Η διαδρομή συνδέθηκε με τη δράση και προστέθηκαν {count} σημεία.",
  "attachRoute.loadActionsError": "Δεν ήταν δυνατή η φόρτωση των δράσεων που μπορείς να επεξεργαστείς.",
  "attachRoute.loadRoutesError": "Δεν ήταν δυνατή η φόρτωση των διαδρομών σου.",
  "attachRoute.permissionError": "Δεν έχεις δικαίωμα να ενημερώσεις αυτή τη δράση ή να ανεβάσεις τη διαδρομή.",
  "attachRoute.routePointsRequired": "Η διαδρομή δεν έχει αρκετά σημεία για σύνδεση με δράση.",
  "attachRoute.genericError": "Δεν ήταν δυνατή η σύνδεση της διαδρομής με τη δράση.",
  "actionForm.createTitle": "Νέα Δράση",
  "actionForm.editTitle": "Επεξεργασία Δράσης",
  "actionForm.subtitle": "Όλες οι δράσεις είναι δημόσια ορατές. Ο τρόπος συμμετοχής ελέγχει μόνο ποιος μπορεί να συμμετέχει.",
  "actionForm.createPill": "Create",
  "actionForm.editPill": "Edit",
  "actionForm.basic": "Βασικά στοιχεία",
  "actionForm.title": "Τίτλος",
  "actionForm.description": "Περιγραφή",
  "actionForm.actionType": "Τύπος δράσης",
  "actionForm.status": "Κατάσταση",
  "actionForm.targetSpeed": "Μέση/στόχος km/h",
  "actionForm.photoUrl": "Photo URL προαιρετικά",
  "actionForm.time": "Χρόνος",
  "actionForm.start": "Έναρξη",
  "actionForm.end": "Λήξη",
  "actionForm.durationHours": "Διάρκεια ώρες",
  "actionForm.registrationDeadline": "Προθεσμία εγγραφών",
  "actionForm.startLocation": "Τοποθεσία εκκίνησης",
  "actionForm.locationName": "Όνομα τοποθεσίας",
  "actionForm.participation": "Συμμετοχές",
  "actionForm.maxParticipants": "Μέγιστοι συμμετέχοντες",
  "actionForm.participationMode": "Τρόπος συμμετοχής",
  "actionForm.allowParticipantLiveMap": "Να επιτρέπεται live χάρτης συμμετεχόντων όπου υποστηρίζεται.",
  "actionForm.route": "Διαδρομή",
  "actionForm.routeDescription": "Μπορείς να αφήσεις τη δράση χωρίς διαδρομή ή να επιλέξεις μία από τις αποθηκευμένες διαδρομές σου.",
  "actionForm.existingRouteWarning": "Η δράση έχει ήδη διαδρομή. Νέα επιλογή θα την αντικαταστήσει μετά από επιβεβαίωση.",
  "actionForm.noRouteChange": "Χωρίς αλλαγή διαδρομής",
  "actionForm.noRouteChangeBody": "Η δράση θα μείνει χωρίς νέα διαδρομή ή θα κρατήσει την υπάρχουσα.",
  "actionForm.replaceRouteConfirm": "Η δράση έχει ήδη διαδρομή. Θέλω να την αντικαταστήσω.",
  "actionForm.transferMarkers": "Μεταφορά σημείων διαδρομής στη δράση ως προσθήκη.",
  "actionForm.checkDetails": "Έλεγξε τα στοιχεία",
  "actionForm.saveAction": "Αποθήκευση Δράσης",
  "actionForm.cancel": "Άκυρο",
  "actionForm.loadingAction": "Φόρτωση δράσης",
  "actionForm.loadingActionBody": "Γίνεται ανάγνωση από το Firestore.",
  "actionForm.signInBody": "Συνδέσου για να δημιουργήσεις ή να επεξεργαστείς δράση.",
  "actionForm.editNotAllowedTitle": "Δεν επιτρέπεται η επεξεργασία",
  "actionForm.editNotAllowedBody": "Προς το παρόν η web επεξεργασία εμφανίζεται μόνο στον διοργανωτή της δράσης.",
  "actionForm.notFoundTitle": "Η δράση δεν βρέθηκε",
  "actionForm.notFoundBody": "Δεν υπάρχει διαθέσιμη δράση για επεξεργασία με αυτόν τον σύνδεσμο.",
  "actionForm.saved": "Η δράση αποθηκεύτηκε.",
  "actionForm.savedLink": "Η δράση αποθηκεύτηκε: /event/{eventId}",
  "actionForm.routeAttachPartialWarning": "Η δράση αποθηκεύτηκε, αλλά η διαδρομή δεν συνδέθηκε. Μπορείς να τη συνδέσεις από τη λεπτομέρεια της δράσης.",
  "actionForm.loadRoutesError": "Δεν ήταν δυνατή η φόρτωση των διαδρομών σου.",
  "actionForm.loadActionError": "Δεν ήταν δυνατή η φόρτωση της δράσης.",
  "actionForm.permissionError": "Δεν έχεις δικαίωμα αποθήκευσης για αυτή τη δράση.",
  "actionForm.saveError": "Δεν ήταν δυνατή η αποθήκευση της δράσης.",
  "actionForm.errorTitleRequired": "Ο τίτλος είναι υποχρεωτικός.",
  "actionForm.errorStartRequired": "Η ημερομηνία έναρξης είναι υποχρεωτική.",
  "actionForm.errorEndAfterStart": "Η λήξη πρέπει να είναι μετά την έναρξη.",
  "actionForm.errorDeadlineBeforeStart": "Η προθεσμία εγγραφών πρέπει να είναι πριν από την έναρξη.",
  "actionForm.errorDuration": "Η διάρκεια πρέπει να είναι τουλάχιστον 1 ώρα.",
  "actionForm.errorParticipants": "Οι συμμετέχοντες πρέπει να είναι θετικός αριθμός.",
  "actionForm.errorLatitude": "Το latitude πρέπει να είναι από -90 έως 90.",
  "actionForm.errorLongitude": "Το longitude πρέπει να είναι από -180 έως 180.",
  "actionForm.errorReplaceRoute": "Η δράση έχει ήδη διαδρομή. Επιβεβαίωσε ότι θέλεις να την αντικαταστήσεις.",

  "detail.resultsLoading": "Φόρτωση αποτελεσμάτων",
  "detail.resultsLoadingBody": "Γίνεται ανάγνωση των αποτελεσμάτων χωρίς αλλαγές σε Firestore.",
  "detail.resultsLoadError": "Δεν ήταν δυνατή η φόρτωση αποτελεσμάτων",
  "detail.resultsLoadErrorBody": "Τα αποτελέσματα θα εμφανιστούν όταν είναι διαθέσιμα και επιτρέπεται η ανάγνωση.",
  "detail.noFinishers": "Δεν υπάρχουν τερματισμοί ακόμα.",
  "detail.nonFinishers": "Αποχωρήσεις / Δεν τερμάτισαν",
  "detail.athlete": "Αθλητής",
  "detail.resultWithdrawn": "Αποχώρησε",
  "detail.resultDnf": "Δεν τερμάτισε",
  "detail.resultDisqualified": "Ακυρώθηκε",

  "results.pageTitle": "Αποτελέσματα",
  "results.pageSubtitle": "Επίλεξε δράση και δες καθαρά τους τερματισμούς, τις αποχωρήσεις και το CSV εξαγωγής.",
  "results.title": "Αποτελέσματα δράσης",
  "results.subtitle": "Κατάταξη και δημόσια ασφαλή στοιχεία αποτελεσμάτων.",
  "results.selectAction": "Επιλογή δράσης",
  "results.selectActionBody": "Εμφανίζονται δημόσιες δράσεις τύπου Brevet ή Race που μπορούν να έχουν αποτελέσματα.",
  "results.loadingActions": "Φόρτωση δράσεων",
  "results.noActionsTitle": "Δεν βρέθηκαν δράσεις με αποτελέσματα",
  "results.noActionsBody": "Όταν υπάρξουν δημόσιες δράσεις Brevet ή Race, θα εμφανιστούν εδώ.",
  "results.chooseActionTitle": "Επίλεξε δράση",
  "results.chooseActionBody": "Άνοιξε μία δράση από τη λίστα για να εμφανιστούν τα αποτελέσματά της.",
  "results.exportCsv": "Εξαγωγή αποτελεσμάτων CSV",
  "results.ranking": "Κατάταξη",
  "results.rankingBody": "Rank παίρνουν μόνο οι αθλητές με κατάσταση FINISHED.",
  "results.nonFinishedBody": "Αθλητές που αποχώρησαν, δεν τερμάτισαν ή ακυρώθηκαν εμφανίζονται χωρίς θέση κατάταξης.",
  "results.filterAll": "Όλοι",
  "results.filterFinished": "Τερμάτισαν",
  "results.filterNonFinished": "Αποχώρησαν / Δεν τερμάτισαν",
  "results.searchName": "Αναζήτηση ονόματος",
  "results.emptyFiltered": "Δεν υπάρχουν αποτελέσματα για αυτό το φίλτρο.",
  "results.rank": "Θέση",
  "results.status": "Κατάσταση",
  "results.athlete": "Αθλητής",
  "results.duration": "Χρόνος",
  "results.distance": "Απόσταση",
  "results.avgSpeed": "Μέση",
  "results.maxSpeed": "Μέγιστη",
  "results.elevationGain": "Υψομετρικά",
  "results.finishTime": "Τερματισμός",
  "results.totalResults": "Σύνολο",
  "results.finishers": "Τερματισμοί",
  "results.withdrawnDnf": "Εκτός κατάταξης",
  "results.fastestDuration": "Ταχύτερος χρόνος",
  "results.averageFinishDuration": "Μέσος χρόνος",
  "results.statusFinished": "Τερμάτισε",
  "results.statusWithdrawn": "Αποχώρησε",
  "results.statusDnf": "Δεν τερμάτισε",
  "results.statusDisqualified": "Ακυρώθηκε",

  "detail.noDescription": "Δεν υπάρχει περιγραφή για αυτή τη δράση.",
  "detail.untilStart": "Έως την έναρξη",
  "detail.basedOnDuration": "Με βάση τη διάρκεια",
  "detail.time": "Χρόνος",
  "detail.start": "Έναρξη",
  "detail.end": "Λήξη",
  "detail.registrationDeadline": "Προθεσμία εγγραφών",
  "detail.location": "Τοποθεσία",
  "detail.noStartLocation": "Δεν έχει δηλωθεί τοποθεσία εκκίνησης",
  "detail.participation": "Συμμετοχή",
  "detail.limit": "Όριο",
  "detail.organizer": "Διοργανωτής",
  "detail.route": "Διαδρομή",
  "detail.routePreview": "Προεπισκόπηση διαδρομής",
  "detail.routePreviewDescription": "Υπάρχουν {routePoints} σημεία προεπισκόπησης και {controlPoints} control σημεία.",
  "detail.routePreviewEmpty": "Η διαδρομή θα εμφανιστεί εδώ όταν υπάρχει διαθέσιμη προεπισκόπηση χάρτη.",
  "detail.links": "Σύνδεσμοι",
  "detail.liveRace": "Live race",
  "detail.missingLinkTitle": "Ο σύνδεσμος δεν είναι πλήρης",
  "detail.missingLinkBody": "Δεν υπάρχει αναγνωριστικό δράσης στον σύνδεσμο.",
  "detail.loadingAction": "Φόρτωση δράσης",
  "detail.loadingActionBody": "Γίνεται ανάγνωση από το Firestore.",
  "detail.loadErrorTitle": "Δεν ήταν δυνατή η φόρτωση",
  "detail.loadErrorBody": "Η δράση δεν είναι διαθέσιμη ή δεν επιτρέπεται η ανάγνωση.",
  "detail.unavailableTitle": "Η δράση δεν είναι διαθέσιμη",
  "detail.unavailableBody": "Οι διαγραμμένες, πρόχειρες ή ακυρωμένες δράσεις δεν εμφανίζονται στη δημόσια προβολή.",
  "detail.nonRaceResultsBody": "Τα αποτελέσματα εμφανίζονται για Brevet ή αγωνιστικές δράσεις όταν υπάρχουν.",
  "detail.manageTitle": "Διαχείριση Δράσης",
  "detail.manageBody": "Organizer-only εργαλεία για συμμετοχές, προσκλήσεις και support/control.",
  "detail.participantsPublicBody": "Δημόσια προβολή ασφαλών συμμετεχόντων.",
  "detail.participant": "Συμμετέχων",
  "detail.participates": "Συμμετέχει",
  "detail.loadingParticipants": "Φόρτωση συμμετεχόντων...",
  "detail.participantsLoadError": "Δεν ήταν δυνατή η φόρτωση των συμμετεχόντων.",
  "detail.noParticipants": "Δεν βρέθηκαν συμμετέχοντες ακόμη.",
  "detail.loadingPermissions": "Φόρτωση δικαιωμάτων",
  "detail.loadingPermissionsBody": "Γίνεται έλεγχος λογαριασμού.",
  "detail.shareTools": "Κοινοποίηση δράσης",
  "detail.shareToolsBody": "Αντιγραφή καθαρού κειμένου ή social link με σωστή προεπισκόπηση για Facebook.",
  "detail.copyShareText": "Αντιγραφή κειμένου κοινοποίησης",
  "detail.copyShareLink": "Αντιγραφή social link",
  "detail.facebookPreviewLink": "Προβολή social preview",
  "detail.shareCopied": "Αντιγράφηκε.",
  "detail.shareCopyFailed": "Δεν ήταν δυνατή η αντιγραφή.",
  "detail.shareOpenInPuls": "Άνοιξε στο PULS:",
  "detail.shareDownloadPuls": "Κατέβασε την εφαρμογή PULS:",
  "detail.shareFooter": "PULS - για ποδήλατα και όχι μόνο 🚴",
  "detail.shareParticipants": "{current} συμμετέχοντες",
  "detail.shareParticipantsWithLimit": "{current}/{max} συμμετέχοντες",

  "roadbook.title": "Roadbook",
  "roadbook.subtitle": "Πίνακας σημείων διαδρομής με km, τύπο, ώρες και ορατότητα.",
  "roadbook.routeEditorTitle": "Πίνακας διαδρομής",
  "roadbook.routeEditorSubtitle": "Όλα τα σημεία του workspace ταξινομημένα με βάση το km.",
  "roadbook.savedRouteTitle": "Roadbook διαδρομής",
  "roadbook.savedRouteSubtitle": "Σημεία ενδιαφέροντος και controls από την αποθηκευμένη διαδρομή.",
  "roadbook.actionTitle": "Roadbook Δράσης",
  "roadbook.publicSubtitle": "Δημόσια σημεία διαδρομής που είναι ορατά στους αθλητές.",
  "roadbook.loading": "Φόρτωση σημείων διαδρομής...",
  "roadbook.print": "Εκτύπωση Roadbook",
  "roadbook.exportCsv": "Εξαγωγή CSV",
  "roadbook.km": "km",
  "roadbook.type": "Τύπος",
  "roadbook.markerTitle": "Τίτλος",
  "roadbook.description": "Περιγραφή",
  "roadbook.openTime": "Άνοιγμα",
  "roadbook.closeTime": "Κλείσιμο",
  "roadbook.visibility": "Ορατότητα",
  "roadbook.actions": "Ενέργειες",
  "roadbook.visible": "Ορατό σε αθλητές",
  "roadbook.hidden": "Κρυφό",
  "roadbook.empty": "Δεν υπάρχουν σημεία διαδρομής.",
  "roadbook.noKm": "Χωρίς km",
  "roadbook.farFromRoute": "Μακριά από διαδρομή",
  "roadbook.publicCount": "{count} δημόσια",
  "roadbook.hiddenCount": "{count} κρυφά",
  "roadbook.edit": "Επεξεργασία",
  "roadbook.recalculateKm": "Επανυπολογισμός km",
  "roadbook.kmRecalculated": "Τα km των σημείων ενημερώθηκαν.",
  "roadbook.kmAlreadyUpdated": "Τα km των σημείων είναι ήδη ενημερωμένα.",

  "community.routesTitle": "Κοινότητα διαδρομών",
  "community.routesSubtitle": "Δημόσιες διαδρομές που έχουν δημοσιευτεί από την Android εφαρμογή.",
  "community.routesCount": "{count} διαδρομές",
  "community.routeDescription": "Δημόσια διαδρομή κοινότητας",
  "community.routeFallback": "Διαδρομή κοινότητας",
  "community.byAuthor": "Από {name}",
  "community.noRating": "Χωρίς βαθμολογία",
  "community.hiddenEndpoints": "Κρυφά άκρα",
  "community.loadingRoutes": "Φόρτωση κοινότητας",
  "community.loadingRoutesBody": "Ανάγνωση public communityRoutes.",
  "community.routesLoadError": "Δεν ήταν δυνατή η φόρτωση",
  "community.routesLoadErrorBody": "Η κοινότητα απαιτεί σύνδεση και public published routes.",
  "community.noRoutes": "Δεν υπάρχουν δημοσιευμένες διαδρομές",
  "community.noRoutesBody": "Οι διαδρομές εμφανίζονται εδώ όταν κάποιος τις δημοσιεύσει από την εφαρμογή.",
  "community.topRated": "Καλύτερες βαθμολογίες",
  "community.difficultyEasy": "Εύκολη",
  "community.difficultyModerate": "Μέτρια",
  "community.difficultyHard": "Δύσκολη",
  "community.difficultyExpert": "Expert",
  "community.suitableHiking": "Περπάτημα",
  "community.suitableRoad": "Δρόμου",
  "community.segmentsTitle": "Τμήματα",
  "community.segmentsSubtitle": "Δημόσια τμήματα/αναβάσεις από την εφαρμογή, με διαχωρισμό ανά προφίλ κίνησης.",
  "community.segmentsCount": "{count} τμήματα",
  "community.segmentDescription": "Δημόσιο τμήμα κοινότητας",
  "community.segmentFallback": "Τμήμα",
  "community.noProfile": "Χωρίς προφίλ",
  "community.profileHiking": "Πεζοπορία",
  "community.attempts": "προσπάθειες",
  "community.loadingSegments": "Φόρτωση τμημάτων",
  "community.loadingSegmentsBody": "Ανάγνωση ACTIVE PUBLIC communitySegments.",
  "community.segmentsLoadErrorBody": "Η ανάγνωση τμημάτων απαιτεί σύνδεση και public active segments.",
  "community.noSegments": "Δεν υπάρχουν τμήματα ακόμη",
  "community.noSegmentsBody": "Τα τμήματα εμφανίζονται εδώ όταν δημιουργηθούν από αποθηκευμένη διαδρομή στην εφαρμογή.",
  "community.leaderboardTitle": "Βαθμολογία τμημάτων",
  "community.leaderboardSubtitle": "Μόνο VALID προσπάθειες, χωριστά ανά προφίλ κίνησης.",
  "community.loadingLeaderboard": "Φόρτωση βαθμολογίας",
  "community.loadingLeaderboardBody": "Ανάγνωση VALID segmentAttempts.",
  "community.leaderboardLoadErrorBody": "Η βαθμολογία απαιτεί σύνδεση και έγκυρες προσπάθειες τμημάτων.",
  "community.noAttempts": "Δεν υπάρχουν έγκυρες προσπάθειες ακόμη",
  "community.noAttemptsBody": "NEEDS_REVIEW και REJECTED προσπάθειες δεν εμφανίζονται στη βαθμολογία."
} as const;
